export function getTagsLabelsForPointType(state, pointTypeId) {
  const pointType = state.entities.pointTypes.byId[pointTypeId];
  const tags = [];
  const labels = [];
  if (pointType) {
    for (let i = 0; i < pointType.tagSetIds.length; i += 1) {
      const tag = state.entities.tags.byId[pointType.tagSetIds[i]];
      if (tag) tags.push(tag);
    }
    for (let i = 0; i < pointType.labels.length; i += 1) {
      const label = state.entities.labels.byName[pointType.labels[i]];
      if (label) labels.push(label);
    }
  }
  return { tags, labels };
}
